import PropTypes from 'prop-types';
import styles from './FJTextToSpeechBottom.module.less';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';
import FJPlayIcon from '../../../../assets/svg/play.svg?react';
import FJAddIcon from '../../../../assets/svg/add-to-media_balck.svg?react';
import FJPauseIcon from '../../../../assets/svg/pause.svg?react';
import classNames from 'classnames';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox.jsx';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJCoinBase64 from '../../../../assets/base64/cion-new.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';
import { useMemo } from 'react';
import FJTextToSpeechConfig from '../../../../config/appConfig/FJTextToSpeechConfig.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';

const FJTextToSpeechBottom = props => {
    const {
        list,
        selectedSpeechIdList,
        setSelectedSpeechIdList,
        setIsSelectAll,
        onHide,
        onDownload,
        freeNumCreation,
        creditNumber,
        currentTime,
        totalTime,
        isPlaying,
        onChangePlay,
        downloadStatus,
        onEditToFlexClip,
        isPlayLoading,
        onShow,
        tooltip,
    } = props;

    const _checkBoxChange = (id, bool) => {
        if (bool) {
            setSelectedSpeechIdList([...selectedSpeechIdList, id]);
        } else {
            setSelectedSpeechIdList(selectedSpeechIdList.filter(item => item !== id));
        }
    };

    const totalCredit = useMemo(() => {
        let credit = 0;
        list.forEach(item => {
            if (selectedSpeechIdList.indexOf(item.id) !== -1 && item.status === FJConstant.DEFAULT) {
                credit += FJTextToSpeechUtil.getUsedCreditByTextLength(item.text.trim().length);
            }
        });
        // 保留3位小数
        return parseFloat(credit.toFixed(3));
    }, [list, selectedSpeechIdList]);

    const _renderTrigger = config => {
        const __onClick = e => {
            if (!FJUtil.isLogin()) {
                FJUtil.anonymousSignUp();
                return;
            }
            config.onClick(e);
        };
        return (
            <FJButton
                className={styles.download}
                text='download'
                type='gradient'
                icon={<FJDownloadIcon />}
                onClick={__onClick}
                ref={config.ref}
                disabled={list.length === 0 || isPlayLoading}
            />
        );
    };

    const isAllSelect = selectedSpeechIdList.length === list.length;
    const scrollHeight = Math.min(list.length * 42, 4 * 42);
    const _renderOverlay = config => {
        return (
            <div ref={config.ref} className={styles.overlay}>
                <div className={styles.title}>{FJLocalStore._('select-speech')}</div>
                <div className={styles.section}>
                    <div className={styles.header}>
                        <div
                            onClick={() => {
                                setIsSelectAll(!isAllSelect);
                            }}
                            className={styles.header_inner}
                        >
                            <FJCheckBox className={styles.check} selected={isAllSelect} dataChange={setIsSelectAll} />
                            {FJLocalStore._('all-speech')}
                        </div>
                    </div>
                    <div className={styles.content}>
                        <FJVerticalScroller className={styles.scroll_box} style={{ height: scrollHeight }}>
                            <div className={styles.inner}>
                                {list.map(item => {
                                    const isSelected = selectedSpeechIdList.indexOf(item.id) !== -1;
                                    return (
                                        <div className={styles.item} key={item.id}>
                                            <div
                                                className={styles.item_left}
                                                onClick={() => {
                                                    _checkBoxChange(item.id, !isSelected);
                                                }}
                                            >
                                                <FJCheckBox
                                                    className={styles.check}
                                                    selected={isSelected}
                                                    dataChange={bool => {
                                                        _checkBoxChange(item.id, bool);
                                                    }}
                                                />
                                                <FJTextWithEllipsis className={styles.text} text={item.text} />
                                            </div>
                                            <>
                                                {item.status === FJConstant.SUCCESS && (
                                                    <div className={styles.complete}>{FJLocalStore._('generated')}</div>
                                                )}
                                                {item.status === FJConstant.DEFAULT && (
                                                    <div className={styles.coin}>
                                                        <img src={FJCoinBase64} alt='' />
                                                        {FJTextToSpeechUtil.getUsedCreditByTextLength(
                                                            item.text.trim().length,
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        </div>
                                    );
                                })}
                            </div>
                        </FJVerticalScroller>
                    </div>
                </div>
                <div className={styles.total}>
                    <div className={styles.total_desc}>{FJLocalStore._('total')}</div>
                    <div className={styles.credits}>
                        <img src={FJCoinBase64} alt='' />
                        {totalCredit}
                    </div>
                </div>
                <div className={styles.btn_box}>
                    <FJButton
                        className={styles.btn}
                        text='use-in-flex-clip'
                        icon={<FJAddIcon />}
                        disabled={selectedSpeechIdList.length === 0}
                        // isLoading={downloadStatus === FJConstant.LOADING}
                        onClick={onEditToFlexClip}
                    />
                    <FJButton
                        className={styles.btn}
                        type='gradient'
                        text='download'
                        icon={<FJDownloadIcon />}
                        onClick={onDownload}
                        disabled={selectedSpeechIdList.length === 0}
                        // isLoading={downloadStatus === FJConstant.LOADING}
                    />
                </div>
            </div>
        );
    };

    const isFree = creditNumber === 0 && freeNumCreation > 0;
    const totalFreeNumCreationTextToSpeech = FJTextToSpeechConfig.totalFreeNumCreationTextToSpeech;

    return (
        <div className={styles.box}>
            <div className={styles.left}>
                <FJToolTip title={tooltip}>
                    <div className={styles.control} onClick={onChangePlay}>
                        {isPlaying ? <FJPauseIcon /> : <FJPlayIcon />}
                        {isPlayLoading && <div className={styles.loading} />}
                    </div>
                </FJToolTip>

                <span className={styles.time}>{FJUtil.formatTime(currentTime, false, 2)}</span>
                <span className={classNames(styles.time, styles.opacity_45)}>
                    / {FJUtil.formatTime(totalTime, false, 2)}
                </span>
            </div>
            <div className={styles.right}>
                {isFree && (
                    <div
                        className={styles.free}
                        dangerouslySetInnerHTML={{
                            __html: FJLocalStore._('free-try-characters').replace(
                                'xxx',
                                `${totalFreeNumCreationTextToSpeech - freeNumCreation}/${totalFreeNumCreationTextToSpeech}`,
                            ),
                        }}
                    />
                )}
                <FJDropdownNew
                    renderTrigger={_renderTrigger}
                    useAnchorBody
                    placement='topRight'
                    trigger='click'
                    renderOverlay={_renderOverlay}
                    offsetTop={-35}
                    onHide={onHide}
                    onShow={onShow}
                />
            </div>
        </div>
    );
};

FJTextToSpeechBottom.propTypes = {
    list: PropTypes.array,
    selectedSpeechIdList: PropTypes.array,
    setSelectedSpeechIdList: PropTypes.func,
    setIsSelectAll: PropTypes.func,
    onHide: PropTypes.func,
    onDownload: PropTypes.func,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    currentTime: PropTypes.number,
    totalTime: PropTypes.number,
    isPlaying: PropTypes.bool,
    onChangePlay: PropTypes.func,
    downloadStatus: PropTypes.string,
    onEditToFlexClip: PropTypes.func,
    isPlayLoading: PropTypes.bool,
    onShow: PropTypes.func,
    tooltip: PropTypes.string,
};
export default FJTextToSpeechBottom;
